import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LaftStatusBannerChip,
  LaftStatusBannerVariant,
} from '../../../constants/laft-status-banner.copy';

const ICON_BASE = '../../../../../assets/icons/';

@Component({
  selector: 'app-banner-laft-status',
  templateUrl: './banner-laft-status.component.html',
  styleUrls: ['./banner-laft-status.component.scss'],
})
export class BannerLaftStatusComponent {
  @Input() title: string;
  @Input() description: string | null = null;
  @Input() chips: LaftStatusBannerChip[] = [];
  @Input() buttonLabel: string | null = null;
  @Input() secondaryButtonLabel: string | null = null;

  @Input() buttonVariant: 'filled' | 'outlined' = 'filled';
  @Input() icon = 'security-user';
  @Input() variant: LaftStatusBannerVariant = 'default';

  @Input() dismissible = false;

  @Output() action = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  get iconPath(): string {
    return `${ICON_BASE}${this.icon}.svg`;
  }

  get tickPath(): string {
    return `${ICON_BASE}tick-circle-green.svg`;
  }

  get closePath(): string {
    return `${ICON_BASE}gray-x.svg`;
  }

  get chipClockPath(): string {
    return `${ICON_BASE}clock.svg`;
  }

  get chipLockPath(): string {
    return `${ICON_BASE}lock-gray.svg`;
  }

  get hasChips(): boolean {
    return (this.chips || []).length > 0;
  }

  // The copy getter composes a fresh chip row on every change-detection pass; without a
  // trackBy the default identity tracking rebuilds all three chips each tick.
  trackByChipLabel(_index: number, chip: LaftStatusBannerChip): string {
    return chip.label;
  }
}
